import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import { getColumns, getData, getIsLoading } from '../redux/selectors/PredesTransactionsHistorySelectors';
import ListTable from '../../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { postPredesTransactionsRejectRequestActionCreator } from '../../../predes/reject/redux/actions/PredesTransactionsRejectActions';
import { getUserRole } from '../../../../../../common/user/redux/selectors/UserDataSelectors';
import PredesTransactionsRelease from '../../../predes/release/containers/PredesTransactionsRelease';
import PredesTransactionsObject from '../../../predes/object/containers/PredesTransactionsObject';
import PredesTransactionsEdit from '../../../predes/edit/container/PredesTransactionsEdit';

class PredesTransactionsHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditFormModal: false,
      showModal: false,
      showObjectModal: false,
    };
    this.applyReject = this.applyReject.bind(this);
    this.applyRelease = this.applyRelease.bind(this);
    this.objectPredes = this.objectPredes.bind(this);
    this.editTransaction = this.editTransaction.bind(this);
  }

  componentDidMount() {
    this.props.tableLoadData({ tableId: 'PREDES_TRANSACTIONS_HISTORY' }, this.props.appContext.appContext, { transactionId: this.props.row.original.id });
  }

  refreshHistories = () => {
    this.props.tableLoadData({ tableId: 'PREDES_TRANSACTIONS_HISTORY' }, this.props.appContext.appContext, { transactionId: this.props.row.original.id });
  }

  showEditFormModal = () => {
    this.setState({
      showEditFormModal: true,
    });
  }

  hideEditFormModal = () => {
    this.setState({
      showEditFormModal: false,
    });
  }

  showReleaseFormModal = () => {
    this.setState({
      showModal: true,
    });
  }

  hideReleaseFormModal = () => {
    this.setState({
      showModal: false,
    });
  }

  showObjectFormModal = () => {
    this.setState({
      showObjectModal: true,
    });
  }

  hideObjectFormModal = () => {
    this.setState({
      showObjectModal: false,
    });
  }

  async applyReject() {
    await this.props.postPredesTransactionsRejectRequestActionCreator(
      this.props.appContext,
      this.props.row.original.comment,
      [this.props.row.original.id],
    );

    this.props.refreshTransactions();
    this.refreshHistories();
  }

  editTransaction() {
    this.setState({
      showEditFormModal: true,
    });
  }

  applyRelease() {
    this.setState({
      showModal: true,
    });
  }

  objectPredes() {
    this.setState({
      showObjectModal: true,
    });
  }

  render() {
    const {
      showEditFormModal,
      showModal,
      showObjectModal,
    } = this.state;
    return (
      <div>
        {this.props.row.original.status !== 'DELETED'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER'))
        && (
          <Button className="action-buttons" onClick={this.editTransaction}>Edit</Button>
        )}
        {this.props.row.original.status === 'ON_HOLD'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons" onClick={this.applyReject}>
            Reject
          </Button>
        )}
        {this.props.row.original.status === 'ON_HOLD'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons" onClick={this.applyRelease}>
            Release
          </Button>
        )}
        {this.props.row.original.status !== 'DELETED'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')
          || this.props.userRole.includes('NATIONAL_PALLET_BOX_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_TRAY_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_BAG_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_PALLET_BOX_EDITOR')
          || this.props.userRole.includes('NATIONAL_TRAY_EDITOR')
          || this.props.userRole.includes('NATIONAL_BAG_EDITOR')) && (
          <Button className="action-buttons" onClick={this.objectPredes}>
            Object
          </Button>
        )}
        <br />
        <br />
        <ListTable
          listId={TableDefinitions.PREDES_TRANSACTIONS_HISTORY.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
        />
        {showEditFormModal && (
          <PredesTransactionsEdit
            openDialog={this.showEditFormModal}
            closeDialog={this.hideEditFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
        {showModal && (
          <PredesTransactionsRelease
            closeDialog={this.hideReleaseFormModal}
            openDialog={this.showReleaseFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
        {showObjectModal && (
          <PredesTransactionsObject
            closeDialog={this.hideObjectFormModal}
            openDialog={this.showObjectFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
  };
}

PredesTransactionsHistoryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  row: PropTypes.objectOf(PropTypes.shape),
  postPredesTransactionsRejectRequestActionCreator: PropTypes.func,
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
  refreshTransactions: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  postPredesTransactionsRejectRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PredesTransactionsHistoryContainer);
